type RequestPasswordResponse = {
    success: boolean;
    message: string;
};

export const requestPasswordEmail = async (email: string): Promise<RequestPasswordResponse> => {
    try {
        const res = await fetch("/api/password", {
            method: "POST", // Cambiado a POST para ajustarse al endpoint
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });

        const data = await res.json();

        if (res.ok) {
            return { success: true, message: "Correo enviado. Revisa tu bandeja de entrada." };
        } else {
            return { success: false, message: data.error || "Ocurrió un error." };
        }
    } catch (error) {
        return { success: false, message: "Error al enviar la solicitud." };
    }
};

export default requestPasswordEmail;
